<div fxLayout="column" fxLayoutAlign="center center">
  <app-nearest-points-list *ngIf="!(metarsLoading$ | async); else loading" [metars]="metars$ | async"
    fxFlex="70"></app-nearest-points-list>
    <ng-template #loading>
      <mat-spinner></mat-spinner>
    </ng-template>
</div>


